import { render, staticRenderFns } from "./rating-item-star.vue?vue&type=template&id=5d03fe17&"
import script from "./rating-item-star.vue?vue&type=script&lang=ts&"
export * from "./rating-item-star.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d03fe17')) {
      api.createRecord('5d03fe17', component.options)
    } else {
      api.reload('5d03fe17', component.options)
    }
    module.hot.accept("./rating-item-star.vue?vue&type=template&id=5d03fe17&", function () {
      api.rerender('5d03fe17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/rating/rating-item-star.vue"
export default component.exports